export enum BotTypeEnum {
  VIDEO_SCENARIO = "VIDEO_SCENARIO",
  TEXT_SCENARIO = "MCBOT_01",
  AI_READY_TO_USE = "KITTY_02",
  AI_WITH_KNOWLEDGE_BASE = "KITTY_03",
  SITE_SCAN_PLUG_AND_PLAY = "KITTY_04",
  HUMAN_CLONE = "CLONE_01"
}
